var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99742 2H2.66552C2.29749 2 1.99915 2.29835 1.99915 2.66638V7.33103C1.99915 7.69906 2.29749 7.99741 2.66552 7.99741H5.99742C6.36545 7.99741 6.6638 7.69906 6.6638 7.33103V2.66638C6.6638 2.29835 6.36545 2 5.99742 2Z",
    stroke: "#D1D5DC",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3276 2H9.99566C9.62763 2 9.32928 2.29835 9.32928 2.66638V4.66552C9.32928 5.03355 9.62763 5.3319 9.99566 5.3319H13.3276C13.6956 5.3319 13.9939 5.03355 13.9939 4.66552V2.66638C13.9939 2.29835 13.6956 2 13.3276 2Z",
    stroke: "#D1D5DC",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3276 7.99609H9.99566C9.62763 7.99609 9.32928 8.29444 9.32928 8.66247V13.3271C9.32928 13.6952 9.62763 13.9935 9.99566 13.9935H13.3276C13.6956 13.9935 13.9939 13.6952 13.9939 13.3271V8.66247C13.9939 8.29444 13.6956 7.99609 13.3276 7.99609Z",
    stroke: "#D1D5DC",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99742 10.6621H2.66552C2.29749 10.6621 1.99915 10.9605 1.99915 11.3285V13.3276C1.99915 13.6957 2.29749 13.994 2.66552 13.994H5.99742C6.36545 13.994 6.6638 13.6957 6.6638 13.3276V11.3285C6.6638 10.9605 6.36545 10.6621 5.99742 10.6621Z",
    stroke: "#D1D5DC",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard2);
export default __webpack_public_path__ + "static/media/dashboard2.1642a2bee0b67767facb22b3131944da.svg";
export { ForwardRef as ReactComponent };